import { render, staticRenderFns } from "./svg_elements.vue?vue&type=template&id=63191a4b"
import script from "./svg_elements.vue?vue&type=script&lang=js"
export * from "./svg_elements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports